export default __webpack_public_path__ + "static/case-logo-2-fdede7b40da4ddd946b6a1a48b3f5421.webp";